var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sc-object-card__image"},[_c('img',{staticClass:"sc-object-card__image-wrapper",attrs:{"src":_vm.imageUrl}})])}
var staticRenderFns = []

export { render, staticRenderFns }